module.exports = __webpack_public_path__ + "img/poker.a54f922d.png";